import $ from 'jquery';
import CustomSelect from './custom-select';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import { initFormControls } from './form-utils';

class ContactPage {
	constructor() {
		this.init();
	}

	init() {
		this.initializeCustomSelects();
		initFormControls('contactForm');
	}

	initializeCustomSelects() {
		CustomSelect.initializeAll('select[data-custom-select]');
	}
}

$(() => {
	new ContactPage();
}); 